import React, { useContext, useEffect, useState } from "react";

// Packages import
import {
  Box,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Pagination,
  Stack,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Chip,
  Switch,
  FormGroup,
  FormControlLabel,
  Paper,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Grid,
  Typography,
} from "@mui/material";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { Search as SearchIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Logout as LogoutIcon } from "@mui/icons-material";

// User Import

import DelModal from "./DelModal";
import { RoutesUrls, adminRoutes } from "../../../Services/Routes/APP";
import { headersPost } from "../../../Services/API";
import { ADMIN_API_ULRS } from "../../../Services/Routes/API";
import { getPagination } from "../../../common/functions";
import {
  DetailsIcon,
  DeletIcon,
  EditIcon1,
  Active,
  Inactive,
} from "../../../Svg";
import { admin_Context } from "../../../context";
import { useDecodedToken } from "../../../Services/Routes/APP/PrivateRoute";

// constants

const headings = ["Name", "Population", "Province", "Actions"];

//component

const Ministry = () => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();

  //states

  const [openModal, setOpenModal] = useState(false);
  const [product, setProduct] = useState(null);
  const [page, setPage] = useState(1);
  const [searched, setSearched] = useState("");
  const [ministries, setMinistries] = useState([]);
  const [filteredMinistries, setFilteredMinistries] = useState([]);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [api, setApi] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);

  const user = useDecodedToken();

  const openn = Boolean(anchorEl);

  const logoutHandler = () => {
    localStorage.clear();
    navigate(RoutesUrls?.root);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  //menu close handler

  const handleClose2 = () => {
    setAnchorEl(null);
  };

  // constant.

  const addHandler = () => {
    navigate(RoutesUrls.admin + adminRoutes.addMinistry);
  };
  const editHandler = (row) => {
    navigate(RoutesUrls.admin + adminRoutes.editMinistry, {
      state: {
        node: row,
      },
    });
  };
  const detailhandler = (row) => {
    navigate(RoutesUrls.admin + adminRoutes.detailsMinistry, {
      state: {
        node: row,
      },
    });
  };

  const closeModalHandler = () => {
    setOpenModal(false);
  };

  const delProduct = (pro) => {
    setProduct(pro);
    setOpenModal(true);
  };

  //get ministries

  const getMinistries = () => {
    const data = {
      page: page,
    };
    setOpen(true);

    headersPost(ADMIN_API_ULRS.GET_ALL_MINISTRIES, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setMinistries(res?.data?.ministries);
          setFilteredMinistries(res?.data?.ministries);
          setTotalCount(res?.data?.total_count);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  //life cycle

  useEffect(() => {
    getMinistries();
  }, [api]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setApi(!api);
  };

  //

  const minitryDelHandler = () => {
    const data = {
      ministry: {
        id: product?.id,
        is_active: !product?.is_active,
      },
    };
    setOpen(true);

    headersPost(ADMIN_API_ULRS.UPDATE_MINISTRY, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setOpenModal(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(!api);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const requestSearch = (searchedVal) => {
    const filteredRows = ministries.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setFilteredMinistries(filteredRows);
  };

  // render

  return (
    <>
      <Box>
        {/* <Box
        display={{ md: "flex", sm: "flex" }}
        justifyContent={{ md: "space-between", sm: "space-between" }}
      >
        <Box paddingBottom={{ xs: 2 }}>
          <Typography>
            <Typography
              variant="h4"
              fontWeight={"bold"}
              component={"span"}
           
            >
              Ministries
            </Typography>
          </Typography>
          <Typography
            variant="subtitle1"
            color={"text.lightGray"}
            sx={{
              paddingBottom: { xs: 0, sm: 1, md: 2 },
              marginTop: -1,
            }}
          >
            Worldwide
          </Typography>
        </Box>
        <Box display={{ xs: "flex" }} justifyContent={{ xs: "right" }}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              color="primary"
              variant="contained"
              size="large"
              onClick={addHandler}
              sx={{
                borderRadius: 1,
                maxHeight: 40,
              }}
              startIcon={<AddIcon />}
            >
              Add Ministry
            </Button>
          
          </Stack>
        </Box>
      </Box> */}

        <Box marginTop={2} display={"flex"} justifyContent={"flex-end"}>
          <TextField
            size="small"
            type="search"
            placeholder="Search by name"
            value={searched}
            onChange={(e) => {
              setSearched(e.target.value);
              requestSearch(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <SearchIcon
                  sx={{
                    color: theme.palette.primary.dark,
                  }}
                />
              ),
            }}
            sx={{
              borderRadius: 25,
              backgroundColor: theme.palette.secondary.dark,
              [`.${outlinedInputClasses.root}`]: {
                borderRadius: 25,
                paddingX: 2,
              },
            }}
          ></TextField>
        </Box>
        <Box mt={2}>
          <Paper elevation={1}>
            <TableContainer>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    {headings?.map((h, index) => (
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                        }}
                        align="center"
                        key={`${index}-table-heading-${h}`}
                      >
                        <Chip
                          label={h}
                          sx={{
                            backgroundColor:
                              index === headings.length - 1
                                ? `${theme.palette.error.light}`
                                : `${theme.palette.secondary.dark}`,
                            borderRadius: 2,
                            color:
                              index === headings.length - 1
                                ? `${theme.palette.error.main}`
                                : `${theme.palette.primary.main}`,
                          }}
                        ></Chip>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredMinistries.length > 0 ? (
                    filteredMinistries?.map((row, index) => (
                      <TableRow
                        // key={row.name}
                        id={row?.id}
                        key={`${index}-row.name-${index + 2}`}
                      >
                        <TableCell
                          sx={{ color: "text.secondary" }}
                          align="center"
                          wordWrap="break-word"
                        >
                          {row?.name}
                        </TableCell>
                        <TableCell
                          sx={{ color: "text.secondary" }}
                          align="center"
                        >
                          {row?.population}
                        </TableCell>
                        <TableCell
                          sx={{ color: "text.secondary" }}
                          align="center"
                        >
                          {row?.state_count}
                        </TableCell>

                        <TableCell align="center">
                          <Stack
                            direction="row"
                            spacing={1}
                            justifyContent={"center"}
                            alignItems="center"
                          >
                            <Button
                              variant="contained"
                              onClick={() => delProduct(row)}
                              size="small"
                              sx={{
                                padding: 0,
                                borderRadius: 4,
                              }}
                            >
                              {row?.is_active ? <Inactive /> : <Active />}
                            </Button>
                            <Button
                              color="secondary"
                              variant="contained"
                              onClick={() => detailhandler(row)}
                              sx={{
                                borderRadius: 1,

                                minWidth: 2,
                                paddingX: 1,
                              }}
                            >
                              <DetailsIcon />
                            </Button>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={() => editHandler(row)}
                              sx={{
                                borderRadius: 1,

                                minWidth: 2,

                                padding: 1,
                              }}
                            >
                              <EditIcon1 />
                            </Button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      {" "}
                      <TableCell colSpan={4}>
                        {" "}
                        <Typography
                          variant="body1"
                          width={"100%"}
                          sx={{
                            textAlign: "center",
                          }}
                        >
                          No Data Found
                        </Typography>{" "}
                      </TableCell>{" "}
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <Box paddingTop={4} display={"flex"} justifyContent={"center"}>
                <Pagination
                  count={totalCount > 10 ? getPagination(totalCount) : 1}
                  page={page}
                  onChange={handleChangePage}
                  color="primary"
                />
              </Box>
            </TableContainer>
          </Paper>
        </Box>

        <DelModal
          status={product?.is_active}
          open={openModal}
          handleClose={closeModalHandler}
          minitryDelHandler={minitryDelHandler}
        />

        <Backdrop
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            color: theme.palette.primary.main,
          }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={alertOpen}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={handleClose} severity={alertIcon}>
            {alertMsg}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
};

export default Ministry;
